module.exports = __webpack_public_path__ + "img/back.157ca9b7.png";